import React, { useState } from 'react';
import Icon from '../../components/AppIcon';
import ColataShell from '../../components/colata/ColataShell';
import TabZone from './components/TabZone';
import TabRicambi from './components/TabRicambi';
import TabComponenti from './components/TabComponenti';
import TabCodifiche from './components/TabCodifiche';
import TabMagazzini from './components/TabMagazzini';

const TABS = [
  { id: 'zone',       label: 'Zone',               icona: 'Layers',     Componente: TabZone },
  { id: 'ricambi',    label: 'Ricambi',            icona: 'Package',    Componente: TabRicambi },
  { id: 'componenti', label: 'Componenti',         icona: 'Cog',        Componente: TabComponenti },
  { id: 'codifiche',  label: 'Cause e codifiche',  icona: 'ListChecks', Componente: TabCodifiche },
  { id: 'magazzini',  label: 'Magazzini',          icona: 'Warehouse',  Componente: TabMagazzini },
];

// /colata-configurazione — gestione di zone, ricambi (reparti e campi), componenti, codifiche e magazzini
const ColataConfigurazionePage = () => {
  const [tabAttivo, setTabAttivo] = useState('zone');
  const corrente = TABS.find((t) => t.id === tabAttivo) ?? TABS[0];
  const Contenuto = corrente.Componente;

  return (
    <ColataShell indietroA="/colata-inventory">
      <div className="w-full animate-in fade-in slide-in-from-bottom-6 duration-700 ease-out">
        {/* Intestazione */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-primary rounded-full" />
            <span className="text-[10px] font-black uppercase tracking-[0.5em] text-muted-foreground/50">
              Sistema di Gestione Colata Continua
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black tracking-[-0.06em] uppercase leading-none text-foreground">
            CONFIGURA<span className="text-primary">ZIONE</span>
          </h2>
        </div>

        {/* Tab bar */}
        <div className="flex overflow-x-auto border-b border-border/40 mb-8" style={{ scrollbarWidth: 'none' }}>
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTabAttivo(t.id)}
              className={`flex items-center justify-center gap-2 py-3 px-4 md:px-6 text-[10px] font-black uppercase tracking-widest rounded-t-xl transition-all duration-200 border-b-2 whitespace-nowrap ${
                tabAttivo === t.id
                  ? 'text-primary border-primary bg-primary/5'
                  : 'text-muted-foreground/50 border-transparent hover:text-muted-foreground'
              }`}
            >
              <Icon name={t.icona} size={12} />
              {t.label}
            </button>
          ))}
        </div>

        {/* Il tab attivo viene montato solo quando serve e ricarica i propri dati */}
        <Contenuto key={corrente.id} />
      </div>
    </ColataShell>
  );
};

export default ColataConfigurazionePage;
